import {QueryCommand} from "xmgoing-server";
import {StorageUtils} from "xmgoing-utils";
import { axiosHelpers } from "@/api/index";
import SysConfigUtils from "@/utils/sysConfigUtils";
import {qiankunWindow} from "vite-plugin-qiankun/dist/helper";

export function useFilePreviewHook({fileObjRef,fileConfigs}: any) {

  const previewUrl = ref('');
  const loadingFlag: any = ref(true);

  const loadEndPage = function () {
    loadingFlag.value = false;
  }

  /**
   * 离线模式预览附件
   * @param fileItem
   * @param backFun
   */
  const openFileByNotOnline = function (fileItem, backFun) {
    const queryCommand = new QueryCommand({
      url: `/api/pe-attachment/oss/fileInfo?fileId=` + fileItem.id,
      method: 'GET'
    });
    queryCommand.executeQueryPromise({params: {}}).then((res: any) => {
      const fileObj = res[0];
      if (fileObj.previewUrl) {
        if (backFun) {
          backFun && backFun(res);
        } else {
          window.open(fileObj.previewUrl);
        }
      }
    });
  }

  //预览地址获取
  const handlePreview = function (fileItem, backFun) {
    const fileShowType = unref(fileConfigs)['showFileType'] || 'wps';
    if (unref(fileShowType) === 'officeLocal') {
      openFileByNotOnline(fileItem, backFun);
    } else {
      let url = "/api/pe-attachment/v3/3rd/config";
      const appidres = axiosHelpers.get(url);
      appidres.then(async (data) => {
        if (qiankunWindow.__POWERED_BY_QIANKUN__) {
          window.open(SysConfigUtils.staticUrl + "/static/web-office-sdk-solution-v2.0.7/test.html?a=" + data.data.data.appid + "&i=" + fileItem.id + "&n=" + fileItem.fileName + "&t=" + StorageUtils.getSessionItem('sessionId'));
        } else {
          if ((window as any).appObj.preview) {
            window.open(SysConfigUtils.staticUrl + "/xm-erp/static/web-office-sdk-solution-v2.0.7/test.html?a=" + data.data.data.appid + "&i=" + fileItem.id + "&n=" + fileItem.fileName + "&t=" + StorageUtils.getSessionItem('sessionId'));
          } else {
            window.open(SysConfigUtils.staticUrl + "/xm-vue-des/static/web-office-sdk-solution-v2.0.7/test.html?a=" + data.data.data.appid + "&i=" + fileItem.id + "&n=" + fileItem.fileName + "&t=" + StorageUtils.getSessionItem('sessionId'));
          }
        }
      })
    }
  }

  /**
   * 查询获取当前预览地址
   */
  const getPreViewUrl = function () {
    loadingFlag.value = true;
    setTimeout(() => {
      loadingFlag.value = false;
    }, 10000)
    handlePreview(unref(fileObjRef), (res) => {
      const fileObj = res[0];
      if (fileObj) {
        previewUrl.value = fileObj.previewUrl
      }
    });
  }


  /**
   * 监听当前附件变化 有则加载预览地址
   */
  watch(fileObjRef, (newVal) => {
    loadingFlag.value = true;
    setTimeout(() => {
      loadingFlag.value = false;
    }, 3000)
    handlePreview(unref(fileObjRef), (res) => {
      const fileObj = res[0];
      if (fileObj) {
        previewUrl.value = fileObj.previewUrl
      }
    });
  }, {
    deep: true
  })

  return {
    getPreViewUrl,
    loadEndPage,
    loadingFlag,
    previewUrl,
    handlePreview
  }
}
